import React, { useState } from "react";
import OfficeImage from "../assets/images/ecl-hotel.webp"; // Replace with your image

// Location data
const LOCATIONS = [
  {
    city: "Tema",
    address: "Enterprise Computing Ltd. Corporate HQ",
    region: "Greater Accra, Ghana",
    mapUrl: "https://maps.app.goo.gl/khLiaBJizh3mCXJ68",
    embedUrl: "https://maps.google.com/maps?q=Enterprise+Computing+Ltd.+Corporate+HQ+Tema+Greater+Accra+Ghana&t=&z=15&ie=UTF8&iwloc=&output=embed",
    flag: "🇬🇭",
  },
  {
    city: "Monrovia",
    address: "Cheeseman Street, Airfield Community, Opposite Starz University",
    region: "Sinkor, Monrovia, Liberia",
    mapUrl: "https://maps.app.goo.gl/vw8GJDpar6oN4gxs5",
    embedUrl: "https://maps.google.com/maps?q=Cheeseman+Street+Sinkor+Monrovia+Liberia&t=&z=15&ie=UTF8&iwloc=&output=embed",
    flag: "🇱🇷",
  },
  {
    city: "ECL Exam Center",
    address: "4th Floor, Giaan Towers, 3B Hospital Rd, Tema",
    region: "Tema, Greater Accra, Ghana",
    mapUrl: "https://maps.app.goo.gl/ScBB11Qhds9uQ7qu8",
    embedUrl: "https://maps.google.com/maps?q=Giaan+Towers+3B+Hospital+Rd+Tema+Ghana&t=&z=15&ie=UTF8&iwloc=&output=embed",
    flag: "🇬🇭",
  },
];




export default function ContactUsPage() {
  const [activeMap, setActiveMap] = useState(0);

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="contact-hero-content">
                <h1 className="contact-hero-title">Let's Talk</h1>
                <p className="contact-hero-description">
                  We'd love to learn more about you and what we can 
                  build together.
                </p>

                <div className="contact-links">
                  <div className="contact-link-item">
                    <span className="contact-link-label">Let's help you</span>
                    <a
                      href="mailto:solutions@ecl-global.com"
                      className="contact-link-email"
                    >
                      solutions@ecl-global.com
                    </a>
                    <br />
                    <span className="contact-link-label">Get in touch</span>
                    <a
                      href="mailto:info@ecl-global.com"
                      className="contact-link-email"
                    >
                      info@ecl-global.com
                    </a>
                  </div>

                  {/* <div className="contact-link-item">
                    <span className="contact-link-label">Join Us</span>
                    <a href="#careers" className="contact-link-action">
                      See Open Positions
                    </a>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="contact-hero-image">
                <img
                  src={OfficeImage}
                  alt="Modern office workspace"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section className="locations-section">
        <div className="container">
          <div className="locations-header">
            <h2 className="locations-title">Locations</h2>
            <p className="locations-description">
              You can find us here. We work with clients all over the world, and we have offices in -
            </p>
          </div>

          <div className="locations-grid">
            {LOCATIONS.map((location, index) => (
              <div
                key={index}
                className={`location-card${activeMap === index ? " location-card--active" : ""}`}
                onClick={() => setActiveMap(index)}
                style={{ cursor: "pointer" }}
              >
                <span style={{ fontSize: "1.5rem", marginBottom: 8, display: "block" }}>
                  {location.flag}
                </span>
                <h3 className="location-city">{location.city}</h3>
                <p className="location-address">{location.address}</p>
                <p className="location-region">{location.region}</p>
                <a
                  href={location.mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="location-map-link"
                  onClick={e => e.stopPropagation()}
                >
                  <i className="bi bi-map me-1" />
                  View on map
                </a>
              </div>
            ))}
          </div>

          {/* Embedded map */}
          <div className="contact-map-wrapper">
            <div className="contact-map-tabs">
              {LOCATIONS.map((loc, i) => (
                <button
                  key={i}
                  className={`contact-map-tab${activeMap === i ? " contact-map-tab--active" : ""}`}
                  onClick={() => setActiveMap(i)}
                >
                  <span>{loc.flag}</span>
                  <span>{loc.city}</span>
                </button>
              ))}
            </div>

            <div className="contact-map-frame">
              {LOCATIONS.map((loc, i) => (
                <iframe
                  key={i}
                  src={loc.embedUrl}
                  title={`ECL office — ${loc.city}`}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    border: "none",
                    display: "block",
                    opacity: activeMap === i ? 1 : 0,
                    pointerEvents: activeMap === i ? "auto" : "none",
                    transition: "opacity 0.3s ease",
                  }}
                />
              ))}
            </div>

            <p style={{ marginTop: 10, fontSize: "0.78rem", color: "#9ca3af", textAlign: "right" }}>
              <i className="bi bi-geo-alt me-1" />
              Click a location card above to switch map
            </p>
          </div>
        </div>
      </section>

      {/* Careers Section */}
      {/* <section className="careers-section" id="careers">
        <div className="container">
          <div className="careers-content">
            <h2 className="careers-title">Join Us</h2>
            <p className="careers-description">
              Work from anywhere. Be part of a global, world-class creative team
              shaping the future of digital.
            </p>

            <div className="careers-positions">
              <h3 className="positions-title">Open Positions</h3>
              <ul className="positions-list">
                {OPEN_POSITIONS.map((position, index) => (
                  <li key={index} className="position-item">
                    <a href="#apply" className="position-link">
                      {position}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section> */}

      {/* Footer Contact Section */}
      {/* <section className="footer-contact-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="footer-contact-info">
                <h3 className="footer-contact-title">Let's Talk</h3>
                <a
                  href="mailto:hello@ecl.com"
                  className="footer-contact-email"
                >
                  hello@ecl.com
                </a>
                <a href="tel:+233123456789" className="footer-contact-phone">
                  +233 12 345 6789
                </a>
              </div>
            </div>

            <div className="col-lg-8">
              <div className="row">
                <div className="col-md-6">
                  <div className="footer-nav">
                    <h4 className="footer-nav-title">Navigation</h4>
                    <ul className="footer-nav-list">
                      <li>
                        <a href="/work">Work</a>
                      </li>
                      <li>
                        <a href="/services">Services</a>
                      </li>
                      <li>
                        <a href="/about">About</a>
                      </li>
                      <li>
                        <a href="/contact">Contact</a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="footer-nav">
                    <h4 className="footer-nav-title">Resources</h4>
                    <ul className="footer-nav-list">
                      <li>
                        <a href="/clients">Clients</a>
                      </li>
                      <li>
                        <a href="/industries">Industries</a>
                      </li>
                      <li>
                        <a href="/blog">Blog</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

       
          <div className="footer-locations">
            <div className="row">
              {FOOTER_LOCATIONS.map((location, index) => (
                <div key={index} className="col-md-3">
                  <div className="footer-location">
                    <h5 className="footer-location-city">{location.city}</h5>
                    <p className="footer-location-address">
                      {location.address}
                    </p>
                    <p className="footer-location-region">{location.region}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

     
          <div className="footer-bottom">
            <div className="footer-social">
              {SOCIAL_LINKS.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="footer-social-link"
                  aria-label={social.name}
                >
                  <i className={`bi bi-${social.icon}`}></i>
                </a>
              ))}
            </div>

            <div className="footer-legal">
              <p className="footer-copyright">
                © 2016–2026 ECL, LLC
              </p>
              <div className="footer-links">
                <a href="/privacy">Privacy</a>
                <a href="/terms">Terms</a>
                <a href="/sitemap">Sitemap</a>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
}